import {
  orderListConfig,
  OrderListItem,
  OrderListQueryConfig,
  ResubmitOrderData,
  SubmitOrderData,
} from '@/api/demand/order.type'
import { AxiosPromise } from 'axios'
import { ResponseData } from 'request'
import request from '@/utils/request'
import { v2Host } from '@/config/host'

// http://10.192.167.79:8267/index.html?urls.primaryName=%E4%BB%93%E5%BA%93%E5%90%8E%E5%8F%B0%E6%8E%A5%E5%8F%A3%E6%96%87%E6%A1%A3#/demand/get_demand_order_list

/**
 * 3D模型工单
 * 撤回工单
 */
export function revokeOrder(data: {
  id: number
}): AxiosPromise<ResponseData<any>> {
  return request({
    url: `${v2Host}/demand/order/revoke`,
    method: 'post',
    data,
  })
}

/**
 * 3D模型工单
 * 工单列表
 */
export function getOrderList(
  params: OrderListQueryConfig,
): AxiosPromise<ResponseData<{ list: OrderListItem[]; total: number }>> {
  return request({
    url: `${v2Host}/demand/order/list`,
    method: 'get',
    params,
  })
}

/**
 * 提交工单
 * @param data
 */
export function submitOrder(
  data: SubmitOrderData,
): AxiosPromise<ResponseData<null>> {
  return request({
    url: `${v2Host}/demand/order/submit`,
    method: 'post',
    data,
  })
}

/**
 * 重新提交工单
 */
export function resubmitOrder(
  data: ResubmitOrderData,
): AxiosPromise<ResponseData<any>> {
  return request({
    url: `${v2Host}/demand/order/resubmit`,
    method: 'post',
    data,
  })
}

// 拒绝工单
export function rejectOrder(data: orderListConfig): AxiosPromise {
  return request({
    url: `${v2Host}/demand/order/reject`,
    method: 'post',
    data: data,
  })
}

// 分配设计
export function assignDesign(data: orderListConfig): AxiosPromise {
  return request({
    url: `${v2Host}/demand/order/assign`,
    method: 'post',
    data: data,
  })
}

// 撤回工单
export function backWardOrder(data: orderListConfig): AxiosPromise {
  return request({
    url: `${v2Host}/demand/order/backward`,
    method: 'post',
    data: data,
  })
}

// 交付/修改物料
export function deliverMaterial(data: orderListConfig): AxiosPromise {
  return request({
    url: `${v2Host}/demand/order/deliver-material`,
    method: 'post',
    data: data,
  })
}

// 交付工单
export function deliverOrder(data: orderListConfig): AxiosPromise {
  return request({
    url: `${v2Host}/demand/order/deliver`,
    method: 'post',
    data: data,
  })
}

export function previewOrderProject(data: { id: number }): AxiosPromise<
  ResponseData<{
    asset_url: string
    order: OrderListItem
    preview_project_id: number
    token: string
  }>
> {
  return request({
    url: `${v2Host}/demand/order/preview-project`,
    method: 'post',
    data,
  })
}
